<template>
  <div
    class="left-0 top-0 z-lines flex h-[calc(100vh-600px)] w-screen items-center justify-center bg-bg-dark"
  >
    <div class="flex flex-col items-center justify-center">
      <div
        class="relative flex animate-pulse items-center justify-center rounded-full"
      >
        <i
          class="fa-thin fa-spinner-third animate-spin text-[96px] text-text-base"
        />
      </div>
    </div>
  </div>
</template>
